<template>
    <div>
        <AlertModal :controller="controller.alertModal" ></AlertModal>
        <ConfirmModal :controller="controller.confirmModal"></ConfirmModal>
        <LoadingModal :controller="controller.loadingModal"></LoadingModal>
        <ConfirmRedeemModal :controller="controller.confirmRedeemModal"></ConfirmRedeemModal>
        <SerialModal :controller="controller.serialModal"></SerialModal>
        <DrawDeliveryModal :controller="controller.drawDeliveryModal"></DrawDeliveryModal>
        <ShippingAddressModal :controller="controller.shippingAddressModal"></ShippingAddressModal>
    </div>
</template>
<script>
//generic
import AlertModal from './Generic/AlertModal/AlertModal.vue';
import ConfirmModal from "./Generic/ConfirmModal/ConfirmModal.vue";
import LoadingModal from './Generic/LoadingModal/LoadingModal.vue';
//redeem
import ConfirmRedeemModal from './ConfirmRedeemModal/ConfirmRedeemModal.vue';
import SerialModal from './SerialModal/SerialModal.vue';
import DrawDeliveryModal from './DrawDeliveryModal/DrawDeliveryModal.vue';
import ShippingAddressModal from './ShippingAddressModal/ShippingAddressModal.vue';

export default {
    name: 'ModalMaster',
    components: {
        AlertModal,
        ConfirmModal,
        LoadingModal,
        ConfirmRedeemModal,
        SerialModal,
        ShippingAddressModal,
        DrawDeliveryModal,
    },
    props: {
        controller: {
            type: Object,
            required: true,
        },
    },
}
</script>
